export default __webpack_public_path__ + "static/media/brand.f568147b.png";